import Vue from 'vue'
import { PLAYBACK_API_TIMEOUT_MS } from './timeouts'

export default {
  apiPrefix: '/api/v2/sites',
  /**
   * edge playback 클립을 생성한다 (save & share): 브릿지에 지정 구간(stime~etime)의 클립 업로드를 요청한다.
   * 실제 클라우드 업로드는 비동기이며, 완료 여부는 getEdgePlaybackFromProxy 폴링으로 추적한다.
   *
   * CHEKT-1406: 전용 edge_playback create 엔드포인트(POST)로 보낸다. 브릿지에 보낼 요청은 백엔드가
   * 만들므로 프런트가 정하는 것은 클립 구간(stime·etime)뿐이다. 대상은 path의 카메라 device_id로
   * 지정하며, 백엔드가 그 카메라로 브릿지·채널(chNN)·파티션을 도출한다.
   * 요청자 신원(user_email·user_id)도 백엔드가 인증된 사용자에서 채운다 — 그 user_id가 업로드 완료
   * 푸시 알림의 수신자를 결정하므로 프런트가 보낸 값을 신뢰하면 안 된다.
   *
   * @param {Object} params
   * @param {number|string} params.siteId   - 사이트 아이디
   * @param {number|string} params.deviceId - 카메라 디바이스 아이디 (브릿지가 아님)
   * @param {string} params.stime           - 클립 시작 시각 (ISO8601 UTC, 예: 2026-07-27T10:00:00Z)
   * @param {string} params.etime           - 클립 종료 시각 (ISO8601 UTC)
   * @returns {Promise} vue-resource 응답 Promise (res.body = 브릿지의 생성 응답, event_id 포함)
   */
  createEdgePlaybackFromProxy: function ({siteId, deviceId, stime, etime}) {
    let timeout = PLAYBACK_API_TIMEOUT_MS / 1000 // 서버 proxy 대기 시간(초). 앱 xhr timeout과 같은 값
    let apiDetailPath = this.apiPrefix + `/${siteId}/devices/${deviceId}/edge_playback?timeout=${timeout}`
    let data = {stime, etime}
    return Vue.http.post(Vue.env.apiPath + apiDetailPath, data, Vue.auth.getBearerHeader(PLAYBACK_API_TIMEOUT_MS))
  },
  getEdgePlaybackFromProxy: function ({siteId, bridgeId, channel}) {
    if (channel < 10) channel = '0' + channel 
    let timeout = PLAYBACK_API_TIMEOUT_MS / 1000 // 서버 proxy 대기 시간(초). 앱 xhr timeout과 같은 값
    let apiDetailPath = this.apiPrefix + `/${siteId}/devices/${bridgeId}/proxy?timeout=${timeout}`
    let bridgeApiPath = `ckbapiv2/camera/ch${channel}/actions/upload_edge_playback?last=true`

    let data = {
      headers: {
        method: 'post',
        path: bridgeApiPath,
        mqttResponseTopic: `devices/${siteId}/${bridgeId}/0/ckbapiv2/res/` + Math.floor(Math.random() * 1000000000000)
      }
    }
    return Vue.http.put(Vue.env.apiPath + apiDetailPath, data, Vue.auth.getBearerHeader(PLAYBACK_API_TIMEOUT_MS))
  },
}